<lib-alert-modal-content
    [cancelButtonLabel]="''"
    [confirmButtonLabel]=confirmButtonLabel
    [headerIconBackgroundColor]=iconColor
    [headerIconBackground]=iconBackgroundColor
    [headerIcon]=icon
    [headerText]=title
    [message]="message"
>
</lib-alert-modal-content>
